import { ReactNode } from "react";
import { Route, RouteObject, Routes } from "react-router-dom";
import routes from "./pages/routes";

import "./App.css";
import { useAuth } from "./providers/AuthProvider";
import BaseLayout from "./components/BaseLayout";
import { ScrollToTop } from "./components/ScrollToTop";

function App() {
  const auth = useAuth();
  const user = auth?.user;

  const renderWithLayout = (element: ReactNode) => (
    <BaseLayout>{element}</BaseLayout>
  );

  const renderRoute = (route: RouteObject) => (
    <Route
      key={route.path}
      path={route.path}
      element={
        user && route.path === "*"
          ? route.element
          : renderWithLayout(route.element)
      }
    />
  );

  return (
    <>
      <ScrollToTop />
      <Routes>{routes.map(renderRoute)}</Routes>
    </>
  );
}

export default App;
